import { useEffect, useState } from 'react';

interface PpxButtonProps {
  data: Record<string, any>;
}

const estiloBoton: React.CSSProperties = {
  display: 'none',
  backgroundColor: '#FAFAFA',
  backgroundImage: 'url(https://sandbox-paybox.pagoplux.com/img/pagar.png?v1)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  height: '96px',
  width: '215px',
  border: 'none',
  cursor: 'pointer',
  backgroundSize: 'contain',
  outline: '0',
  boxShadow: '0px 2px 2px lightgray',
};

const PpxButton: React.FC<PpxButtonProps> = ({ data }) => {
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    // onAuthorize se captura aparte: no puede quedar en window.data porque
    // el SDK envía ese objeto por postMessage y las funciones no son serializables.
    const { onAuthorize: authorizeHandler, ...sdkData } = data;
    (window as any).data = sdkData;
    (window as any).onAuthorize = function (response: any) {
      if (authorizeHandler) authorizeHandler(response);
    };

    // Eliminar instancia anterior completa
    const existing = document.getElementById('ppx-sdk');
    if (existing) existing.remove();

    const existingModal = document.getElementById('modalPaybox');
    if (existingModal) existingModal.innerHTML = '';

    const script = document.createElement('script');
    script.id = 'ppx-sdk';
    script.src = process.env.REACT_APP_PAYBOX_SCRIPT_URL ||
      'https://sandbox-paybox.pagoplux.com/paybox/index.js';

    script.onload = () => {
      const jq = (window as any).jQuery;
      if (jq && !(window as any)._ppxLoaded) {
        (window as any)._ppxLoaded = true;
        jq(window).trigger('load');
      }
      setTimeout(() => {
        const btn = document.getElementById('pay');
        if (btn) btn.click();
        else setLoadError(true);
      }, 2000);
    };

    script.onerror = () => setLoadError(true);
    document.body.appendChild(script);

    return () => {
      (window as any)._ppxLoaded = false;
      const s = document.getElementById('ppx-sdk');
      if (s) s.remove();
    };
  }, [data]);

  return (
    <>
      <div id="modalPaybox"></div>
      <button style={estiloBoton} id="pay" type="submit"></button>
      {loadError && (
        <p style={{ color: '#ef4444', fontSize: '0.85rem', textAlign: 'center', marginTop: 12 }}>
          No se pudo cargar el formulario de pago, por favor recarga la página
        </p>
      )}
    </>
  );
};

export default PpxButton;
